<template>
  <v-container>
    <landing-create :content="content"></landing-create>
    <permit-form
      :onSubmit="onSubmit"
      :isLoading="isLoading"
    ></permit-form>
  </v-container>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import PermitForm from './PermitForm.vue';
import services from '../../../services';
import utilities from '../../../utilities';

const { ErrorMessageUtil } = utilities;
const { documentRegistry } = services;
const { permitService } = documentRegistry;

export default {
  name: 'PermitCreate',
  components: {
    PermitForm,
    LandingCreate,
  },
  data: () => ({
    isLoading: false,
    content: {
      pageTitle: 'Permit Create',
      enableBackButton: true,
    },
  }),
  methods: {
    async onSubmit(data) {
      try {
        const permitData = {
          name: data.name,
          description: data.description,
        };
        this.isLoading = true;

        const permit = await permitService
          .create({ permit: permitData });

        const { _id } = permit;

        const formData = new FormData();
        formData.append('attachment', data.attachment[0]);
        await permitService.upload({ id: _id, formData });

        this.isLoading = false;

        this.$snackbar.showOk({ text: 'Successfully created permit!' });

        this.$router.push({ name: 'permit.list' });
      } catch (e) {
        this.isLoading = false;
        const error = e.response.data;
        this.$snackbar.showBad({
          text: ErrorMessageUtil.transform(error),
        });
      }
    },
  },
};
</script>
